import loadable from '@loadable/component';
import { PropsWithChildren } from 'react';
import { LoadableFunctionalComponent } from '../../utils/index.ts';
import { ImageLoader } from '../../shared/index.ts';
import { ImageComponentViewProps } from './component/types.ts';

export const Image = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.ImageComponent,
  fallback: <ImageLoader />,
}) as LoadableFunctionalComponent<PropsWithChildren<ImageComponentViewProps>>;
